const SET_MONACODE_VALUE = 'scratch-gui/monitors/SET_MONACODE_VALUE';

const initialState = {
    value: ''
}

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
        case SET_MONACODE_VALUE:
            return Object.assign({}, state, {
                value: action.value
            });
        default:
            return state;
    }
};

const setCodeValue = function (code) {
    return {
        type: SET_MONACODE_VALUE,
        value: code
    };
};

export {
    reducer as
    default,
    initialState as monaCodeInitialState,
    setCodeValue
};
